<template>
  <div v-if="isLoading()" class="loader center-middle">
    <Icon :size="50" class="rotating" icon="loader" color="gamma" />
  </div>
  <ErrorSection v-else-if="isErrored()" />
  <div v-else-if="sharedHost">
    <PageTitle>
      <div class="d-flex">{{ getDomain() }}</div>
      <HorizontalList :items="getAttributes()" />
      <template #actions>
        <Btn variant="primaryOutline" @click="openControlPanel" class="mr-2">
          {{ $t("global.control-panel") }}
        </Btn>
        <DropDown :items="getActions()">
          <Btn>{{ $t("global.actions") }} <Icon :size="10" icon="down" class="ml-2" /></Btn>
        </DropDown>
      </template>
    </PageTitle>
    <router-view v-if="!isLoading()" :key="routePath" />
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import Btn from "@/components/display/Btn";
import ContactSupport from "@/components/smart/modals/ContactSupport";
import DropDown from "@/components/display/DropDown";
import ErrorSection from "@/components/display/ErrorSection";
import HorizontalList from "@/components/display/HorizontalList";
import Icon from "@/components/display/icon/Icon";
import NavLink from "@/classes/NavLink";
import PageTitle from "@/components/display/PageTitle";
import store from "@/store";

export default {
  name: "SharedHostingDetailPage",
  components: {
    Btn,
    DropDown,
    ErrorSection,
    HorizontalList,
    Icon,
    PageTitle,
  },
  props: {
    id: {
      number: String,
      required: true,
    },
  },
  setup(props, { root }) {
    const sharedHost = computed(() => store.getters["sharedHosts/getItem"]);
    const status = computed(() => store.getters["sharedHosts/getItemStatus"]);

    const getAttributes = () => [
      { key: root.$t("global.description"), value: getDescription() },
      { key: root.$t("global.renewal-date"), value: getRenewalDate() },
      { key: root.$t("global.ip-address"), value: getIp(), canCopy: true },
    ];
    const getDescription = () => sharedHost.value.description;
    const getDomain = () => sharedHost.value.domain;
    const getIp = () => sharedHost.value.ip;
    const getRenewalDate = () => sharedHost.value.billing.formattedNextBillDate;

    const isErrored = () => status.value.isErrored;
    const isLoading = () => status.value.isLoading;

    const routePath = computed(() => root.$route.fullPath);

    const getActions = () => {
      const links = [
        new NavLink(root.$t("global.contact-support"), null, () => {
          store.dispatch("modals/open", {
            template: ContactSupport,
            data: { serviceId: sharedHost.value.id, department: root.$t("global.support") },
          });
        }),
      ];

      if (sharedHost.value.isCancellable) {
        links.push(
          new NavLink(
            root.$t("global.request-cancellation"),
            null,
            () => {
              root.$router.push({
                name: "request-cancellation",
                params: { id: sharedHost.value.id, type: "sharedHosts" },
              });
            },
            false,
            "danger"
          )
        );
      }

      return links;
    };

    onMounted(() => {
      store.dispatch("sharedHosts/getItem", props.id);
    });

    const openControlPanel = () => {
      window.open(
        `https://${sharedHost.value.hostname}:2443/siteworx/?domain=${sharedHost.value.domain}`,
        "_blank",
        "noopener, noreferrer"
      );
    };

    return {
      getActions,
      getAttributes,
      getDomain,
      isErrored,
      isLoading,
      openControlPanel,
      sharedHost,
      routePath,
    };
  },
};
</script>
